// 资格验证模块路由配置 require 异步按需加载
export default [
  {
    path: '/verify',
    name: 'Verify',
    component: (resolve) => require(['@/views/verify/Verify'], resolve),
    meta: {
      index: '1',
      title: '资格验证'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/verify/verify.js